var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2929 14.7071C13.6834 15.0976 14.3166 15.0976 14.7071 14.7071C15.0976 14.3166 15.0976 13.6834 14.7071 13.2929L13.2929 14.7071ZM2.70711 1.29289C2.31658 0.902369 1.68342 0.902369 1.29289 1.29289C0.902369 1.68342 0.902369 2.31658 1.29289 2.70711L2.70711 1.29289ZM14.7071 2.70711C15.0976 2.31658 15.0976 1.68342 14.7071 1.29289C14.3166 0.902369 13.6834 0.902369 13.2929 1.29289L14.7071 2.70711ZM1.29289 13.2929C0.902369 13.6834 0.902369 14.3166 1.29289 14.7071C1.68342 15.0976 2.31658 15.0976 2.70711 14.7071L1.29289 13.2929ZM14.7071 13.2929L8.70711 7.29289L7.29289 8.70711L13.2929 14.7071L14.7071 13.2929ZM8.70711 7.29289L2.70711 1.29289L1.29289 2.70711L7.29289 8.70711L8.70711 7.29289ZM8.70711 8.70711L14.7071 2.70711L13.2929 1.29289L7.29289 7.29289L8.70711 8.70711ZM7.29289 7.29289L1.29289 13.2929L2.70711 14.7071L8.70711 8.70711L7.29289 7.29289Z",
    fill: "#1D2D4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d1de76fd533588de8563eb7d430ecc26.svg";
export { ForwardRef as ReactComponent };